module.exports = __webpack_public_path__ + "static/media/DSA_RoadmapFAANG.9a101468.pdf";